var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7V5H7.5V7H9.5Z",
    fill: "#282829"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9H11.5V7H9.5V9Z",
    fill: "#282829"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9H7.5V11H9.5V9Z",
    fill: "#282829"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3457 14.845V14.48H12.8907V17.95H13.3457V16.465C13.5057 16.7299 13.8307 16.865 14.1607 16.865C14.8007 16.865 15.3307 16.395 15.3307 15.655C15.3307 14.915 14.8007 14.43 14.1607 14.43C13.8307 14.43 13.5057 14.58 13.3457 14.845ZM14.1157 16.42C13.7407 16.42 13.3507 16.16 13.3507 15.66C13.3507 15.165 13.7057 14.875 14.1157 14.875C14.5357 14.875 14.8707 15.195 14.8707 15.66C14.8707 16.125 14.5357 16.42 14.1157 16.42Z",
    fill: "#282829"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1298 14.48V16.815H11.6798V14.48H12.1298Z",
    fill: "#282829"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5898 13.62C11.5898 13.445 11.7298 13.325 11.9048 13.325C12.0798 13.325 12.2198 13.445 12.2198 13.62C12.2198 13.795 12.0798 13.915 11.9048 13.915C11.7298 13.915 11.5898 13.795 11.5898 13.62Z",
    fill: "#282829"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.055 14.855V14.48H9.08V14.915H10.39L9 16.44V16.815H11.055V16.38H9.64L11.055 14.855Z",
    fill: "#282829"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14973 22H16.8503C18.6016 22 19.5 21.0615 19.5 19.2313V4.75927C19.5 2.92914 18.5926 2 16.8503 2H7.14973C5.40744 2 4.5 2.92914 4.5 4.75927V19.2313C4.5 21.0615 5.39837 22 7.14973 22ZM16.7868 3.15439C17.8394 3.15439 18.3748 3.75504 18.3748 4.78742V19.2032C18.3748 20.2637 17.8394 20.8362 16.7958 20.8362H7.20417C6.16062 20.8362 5.62523 20.2637 5.62523 19.2032V4.78742C5.62523 3.75504 6.16062 3.15439 7.21325 3.15439H9.5V5H11.5V3.15439H16.7868Z",
    fill: "#282829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipIcon);
export default __webpack_public_path__ + "static/media/ZipIcon.4ea544bbdb9b70d55a4dc83371c6e0b3.svg";
export { ForwardRef as ReactComponent };